// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"239":"pieChart","571":"settings"}[chunkId] + "." + {"239":"4a0ca365013f37b175db","571":"2ce061988afdaa0060cf"}[chunkId] + ".js";
};